import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useCreateComercialTableStore } from '../CreateComercialTable.store';
import * as service from '../services';
import * as utils from '../../../utils';

type Params = {
  page: number;
  size: number;
  query: string | null;
  campoOrdenacao: 'CODIGO_PRODUTO' | 'DESCRICAO_PRODUTO' | 'FAMILIA' | 'PRECO_TABELA_BASE';
  ordemOrdenacao: 'CRESCENTE' | 'DECRESCENTE';
};

const params: Params = {
  page: 0,
  size: 10,
  query: null,
  campoOrdenacao: 'CODIGO_PRODUTO',
  ordemOrdenacao: 'CRESCENTE',
};

export const useProductDetailingList = () => {
  const [productListPage, setProductListPage] = useState(params);
  const [productListSort, setProductListSort] = useState({ column: 'CODIGO_PRODUTO', type: 'asc' });

  const { createComercialTableBody, setCreateComercialTableState } = useCreateComercialTableStore();

  const getBaseProductData = async (params: any) => {
    const res = await service.getBaseProductList(params);
    return res;
  };

  const actionSuccess = data => {
    // Compara e preenche os produtos do filtro com os produtos da tabela de detalhamento
    const productList = data.data.content.map(item => {
      const hasInList = createComercialTableBody.produtosBase.some(itemA => itemA.idProduto === item.id);
      const product = createComercialTableBody.produtosBase.find(itemA => itemA.idProduto === item.id);
      const percentual = hasInList ? product.percentual : 0;
      const descontoMaximo = hasInList ? product.descontoMaximo : 0;
      return { ...item, selected: hasInList, percentual, descontoMaximo };
    });
    const newData = {
      ...data.data,
      content: productList,
    };

    setCreateComercialTableState('productDetailingList', newData);
  };

  const { isFetching, refetch } = useQuery({
    queryKey: ['product-detailing-list', productListPage],
    queryFn: () => getBaseProductData(productListPage),
    onSuccess: data => actionSuccess(data),
    retry: false,
    enabled: createComercialTableBody.produtosBase[0]?.idProduto !== 0,
  });

  const handleChangeProductDetailingPage = item => {
    setProductListPage({
      ...productListPage,
      page: item - 1,
    });
  };

  const handleChangeProductDetailingLength = item => {
    setProductListPage({
      ...productListPage,
      size: item,
    });
  };

  const handleChangeProductDetailingColumnSort = (column, type) => {
    if (column && type) {
      setProductListSort({ column, type });
      setProductListPage({
        ...productListPage,
        campoOrdenacao: utils.sortColumnNames[column],
        ordemOrdenacao: utils.sortTypesNames[type],
      });
    }
  };

  return {
    productListSort,
    isLoadingProductDetailing: isFetching,
    refetchProductDetailing: refetch,
    handleChangeProductDetailingPage,
    handleChangeProductDetailingColumnSort,
    handleChangeProductDetailingLength,
  };
};
